export default "__VITE_ASSET__CpF$DVRu__"